import { render, staticRenderFns } from "./ymqcPackage_list.vue?vue&type=template&id=8b265b64&scoped=true&"
import script from "./ymqcPackage_list.vue?vue&type=script&lang=js&"
export * from "./ymqcPackage_list.vue?vue&type=script&lang=js&"
import style0 from "./ymqcPackage_list.vue?vue&type=style&index=0&id=8b265b64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b265b64",
  null
  
)

export default component.exports